import clsx from "clsx";
import { memo, useState } from "react";
import { SketchPicker } from "react-color";
import { getRandomRgbaColor, rgbaObjectToString } from "../../helpers/utils";
import FieldLabel from "../FieldLabel/FieldLabel";
import { MdOutlinePalette } from "react-icons/md";
import { useTranslation } from "react-i18next";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { ICON_SIZES } from "src/constants/icons";

interface IColor {
  r: any;
  g: any;
  b: any;
  a: any;
}

interface IColorPicker {
  color: IColor;
  onChange: (color: any) => void;
  label?: string;
  required?: boolean;
  textColor: IColor;
  showText?: boolean;
  className?: string;
}

const ColorPicker: React.FC<IColorPicker> = ({
  color = { r: 0, g: 0, b: 0, a: 1 },
  onChange = () => {},
  label,
  required,
  textColor,
  showText = true,
  className,
}) => {
  const { t } = useTranslation();
  const [showColorPicker, setShowColorPicker] = useState<boolean>(false);

  return (
    <>
      <div>
        {label && (
          <FieldLabel
            required={required}
            text={label}
            valid={!!textColor}
            onClick={() => setShowColorPicker(true)}
          />
        )}
        <div className={clsx(["flex", "w-full", "gap-2", className])}>
          <div
            className={clsx([
              "flex",
              "w-full",
              "rounded",
              "text-sm",
              "font-normal",
              "items-center",
              "justify-center",
              "h-[40px] md:h-[40px]",
              "rounded",
              "cursor-pointer",
              "border",
              "border-gray-50 dark:border-gray-600",
            ])}
            style={{
              backgroundColor: rgbaObjectToString(color),
              color: rgbaObjectToString(textColor),
            }}
            onClick={() => setShowColorPicker(!showColorPicker)}
            title="Seleccionar color"
          >
            {showText && (
              <>
                R: {color.r} G: {color.g} B: {color.b} A: {color.a}
              </>
            )}
          </div>
          <div>
            <ButtonGroup
              gap={1}
              buttons={[
                // {
                //   tooltip: t("common:buttons.choose"),
                //   onClick: () => {
                //     setShowColorPicker(true);
                //   },
                //   icon: <MdOutlinePalette size={ICON_SIZES.SM} />,
                // },
                {
                  tooltip: t("misc:strings.random_color"),
                  onClick: () => {
                    onChange({
                      rgb: getRandomRgbaColor(1),
                    });
                  },
                  icon: <MdOutlinePalette size={ICON_SIZES.SM} />,
                },
              ]}
            />
          </div>
        </div>
      </div>
      {showColorPicker && (
        <>
          <div
            className={clsx([
              "fixed",
              "top-0",
              "left-0",
              "right-0",
              "bottom-0",
              "bg-black/20",
              "z-50",
            ])}
            onClick={() => setShowColorPicker(false)}
          />

          <div
            className={clsx([
              "z-50",
              "fixed",
              "left-1/2",
              "top-1/2",
              "-translate-x-1/2",
              "-translate-y-1/2",
            ])}
          >
            <SketchPicker
              width="270px"
              color={color}
              onChange={(data) => {
                onChange(data);
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default memo(ColorPicker);
